var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#googlePlay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M260 80H10C4.5 80 0 75.5 0 70V10C0 4.5 4.5 0 10 0h250c5.5 0 10 4.5 10 10v60c0 5.5-4.5 10-10 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A5",
    d: "M260 1.6c4.6 0 8.4 3.8 8.4 8.4v60c0 4.6-3.8 8.4-8.4 8.4H10c-4.6 0-8.4-3.8-8.4-8.4V10c0-4.6 3.8-8.4 8.4-8.4zm0-1.6H10C4.5 0 0 4.5 0 10v60c0 5.5 4.5 10 10 10h250c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M94.8 20.5c0 1.7-.5 3-1.5 4-1.1 1.2-2.6 1.8-4.4 1.8-1.7 0-3.2-.6-4.4-1.8q-1.8-1.8-1.8-4.5t1.8-4.5c1.2-1.2 2.7-1.8 4.4-1.8.9 0 1.7.2 2.5.5s1.4.8 1.9 1.3l-1.1 1.1c-.8-.9-1.9-1.4-3.3-1.4-1.3 0-2.4.4-3.3 1.3s-1.4 2-1.4 3.5c0 1.4.5 2.6 1.4 3.5s2 1.3 3.3 1.3 2.5-.4 3.4-1.3c.6-.6.9-1.4 1-2.4h-4.4v-1.4h5.8c.1.2.1.5.1.8Zm9.299-5h-5.5v3.8h4.9v1.4h-4.9v3.8h5.5V26h-7V14h7zm6.5 10.5h-1.6V15.5h-3.4V14h8.2v1.5h-3.4V26zm9.3 0V14h1.5v12zm8.4 0h-1.5V15.5h-3.4V14h8.2v1.5h-3.4V26zm18.9-1.6c-1.2 1.2-2.6 1.8-4.4 1.8s-3.2-.6-4.4-1.8-1.8-2.7-1.8-4.4.6-3.2 1.8-4.4 2.6-1.8 4.4-1.8c1.7 0 3.2.6 4.4 1.8s1.8 2.7 1.8 4.4c0 1.8-.6 3.2-1.8 4.4Zm-7.6-1c.9.9 2 1.3 3.3 1.3s2.4-.4 3.3-1.3 1.3-2 1.3-3.4-.4-2.5-1.3-3.4-2-1.3-3.3-1.3-2.4.4-3.3 1.3-1.3 2-1.3 3.4c-.1 1.4.4 2.5 1.3 3.4Zm11.6 2.6V14h1.9l5.8 9.3h.1l-.1-2.3v-7h1.5v12h-1.6l-6.1-9.8h-.1l.1 2.3V26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.298 43.5c-4.7 0-8.5 3.6-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.6 8.5-8.5-3.8-8.5-8.5-8.5m0 13.7c-2.6 0-4.8-2.1-4.8-5.2s2.2-5.2 4.8-5.2 4.8 2.1 4.8 5.2c0 3-2.3 5.2-4.8 5.2m-18.7-13.7c-4.7 0-8.5 3.6-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.6 8.5-8.5c.1-4.9-3.8-8.5-8.5-8.5m0 13.7c-2.6 0-4.8-2.1-4.8-5.2s2.2-5.2 4.8-5.2 4.8 2.1 4.8 5.2c0 3-2.2 5.2-4.8 5.2m-22.1-11.1v3.6h8.6c-.3 2-.9 3.5-2 4.5-1.3 1.3-3.2 2.6-6.7 2.6-5.3 0-9.5-4.3-9.5-9.6s4.2-9.6 9.5-9.6c2.9 0 5 1.1 6.5 2.6l2.5-2.5c-2.2-2.1-5-3.6-9.1-3.6-7.3 0-13.4 5.9-13.4 13.2s6.1 13.2 13.4 13.2c3.9 0 6.9-1.3 9.2-3.7 2.4-2.4 3.1-5.7 3.1-8.4 0-.8-.1-1.6-.2-2.3zm90.6 2.8c-.7-1.9-2.9-5.4-7.3-5.4s-8 3.4-8 8.5c0 4.8 3.6 8.5 8.4 8.5 3.9 0 6.2-2.4 7.1-3.8l-2.9-1.9c-1 1.4-2.3 2.4-4.2 2.4s-3.3-.9-4.1-2.6l11.4-4.7zm-11.6 2.9c-.1-3.3 2.5-5 4.4-5 1.5 0 2.7.7 3.2 1.8zm-9.2 8.2h3.7V35h-3.7zm-6.2-14.6h-.1c-.8-1-2.4-1.9-4.5-1.9-4.3 0-8.2 3.7-8.2 8.5s3.9 8.5 8.2 8.5c2 0 3.6-.9 4.5-1.9h.1v1.2c0 3.3-1.7 5-4.5 5-2.3 0-3.7-1.6-4.3-3l-3.3 1.4c.9 2.3 3.4 5 7.5 5 4.4 0 8.1-2.6 8.1-8.9V44h-3.5zm-4.3 11.8c-2.6 0-4.7-2.2-4.7-5.1 0-3 2.2-5.2 4.7-5.2s4.5 2.2 4.5 5.2c.1 2.9-1.9 5.1-4.5 5.1m48.8-22.2h-8.9v25h3.7v-9.5h5.2c4.1 0 8.2-3 8.2-7.8s-4.1-7.7-8.2-7.7m.1 12h-5.3v-8.6h5.3c2.8 0 4.4 2.3 4.4 4.3s-1.6 4.3-4.4 4.3m23.1-3.5c-2.7 0-5.5 1.2-6.7 3.8l3.3 1.4c.7-1.4 2-1.8 3.4-1.8 1.9 0 3.9 1.2 3.9 3.2v.3c-.7-.4-2.1-1-3.9-1-3.6 0-7.2 2-7.2 5.6 0 3.3 2.9 5.5 6.2 5.5 2.5 0 3.9-1.1 4.8-2.4h.1V60h3.6v-9.6c.1-4.5-3.3-6.9-7.5-6.9m-.5 13.7c-1.2 0-2.9-.6-2.9-2.1 0-1.9 2.1-2.7 4-2.7 1.6 0 2.4.4 3.4.8-.3 2.3-2.3 4-4.5 4m21.2-13.2-4.3 10.8h-.1l-4.5-10.8h-4l6.7 15.2-3.8 8.4h3.9l10.2-23.6zm-33.6 16h3.7V35h-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BC8F3",
    d: "M20.9 15.1c-.6.6-.9 1.6-.9 2.8v44.2c0 1.2.3 2.2.9 2.8l.1.1 24.8-24.8v-.5L21 14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#googlePlay_svg__b)",
    d: "m54 48.5-8.3-8.3v-.5l8.3-8.3.2.1 9.8 5.6c2.8 1.6 2.8 4.2 0 5.8l-9.8 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#googlePlay_svg__c)",
    d: "m54.198 48.4-8.4-8.4-24.9 24.9c.9 1 2.4 1.1 4.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#googlePlay_svg__d)",
    d: "M54.2 31.6 25 15c-1.7-1-3.2-.9-4.2.1l25 24.9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlay_svg__b",
    x1: 62.176,
    x2: 13.823,
    y1: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FBBC0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F9A418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlay_svg__c",
    x1: 49.627,
    x2: 4.148,
    y1: 44.586,
    y2: 90.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5166C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlay_svg__d",
    x1: 3.948,
    x2: 41.081,
    y1: -10.268,
    y2: 26.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269E6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#2BA06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#53B26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#6BBD69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C168"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "googlePlay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v80H0z"
  })))));
};
export default SvgGooglePlay;